<div class="container compose-email-page">
    <header class="m-b-md">
        <h2 class="strong">New Message</h2>
        <a *ngIf="!isSpinnerShow" [routerLink]="['/email-merge']" class="close">×</a>
    </header>
    <main>
        <form #form="ngForm"
              autocomplete="off"
              (ngSubmit)="onSubmit(form)"
              [ngClass]="{'ng-submitted': form.submitted, 'sk-loading': isSpinnerShow}">
            <div class="schedule-header m-b-md" *ngIf="data.status == 'scheduled'">
                This email is scheduled to be sent on {{data.scheduleDate | date: 'd MMM yyyy':'+0000'}} at {{data.scheduleDate | date: 'h:mm a':'+0000'}}
                <i class="fa fa-trash pull-right" (click)="removeScheduling()"></i>
                <i class="fa fa-pencil pull-right" (click)="showEmailSchedulingModal()"></i>
            </div>
            <div class="form-group row">
                <div class="col-xs-2">
                    <label class="title">From: </label>
                </div>
                <div class="col-xs-10 from-field display-flex">

                    <div class="from-value">
                        <span>{{senderName}} ({{ from }})</span>
<!--                        <i class="fa fa-pencil pull-right"-->
<!--                           title="Edit"-->
<!--                           (click)="fromCopy = from; senderNameCopy = senderName; isFromEditMode = true;">-->
<!--                        </i>-->
                    </div>

                </div>
            </div>
            <div class="form-group row">
                <div class="col-xs-2">
                    <label class="title">To: </label>
                </div>
                <div class="col-xs-10">
                    <recipients-filter-view [recipientFilterState]="recipientFilterState"></recipients-filter-view>
                </div>
            </div>
            <div class="form-group row reply-to-field">
                <div class="col-xs-2">
                    <label class="title">Reply To:</label>
                </div>
                <div class="col-sm-10">
                    <div *ngIf="data.replyToName || data.replyTo" style="padding: 0 12px;">
                        {{ data.replyToName + ' (' + data.replyTo + ' )' }}
                        <i class="fa fa-times-circle m-t-7"
                           aria-hidden="true"
                           (click)="data.replyTo = ''; data.replyToName = ''; replyToRecipientSearch = '';"></i>
                    </div>
                    <input name="replyToRecipientSearch"
                           id="replyToRecipientSearch"
                           class="form-control"
                           [(ngModel)]="replyToRecipientSearch"
                           *ngIf="!(data.replyToName || data.replyTo)"
                           [disabled]="data.replyToName || data.replyTo || showUsersSpinner"
                           matInput
                           [matAutocomplete]="emailList">
                    <mat-autocomplete #emailList="matAutocomplete" (optionSelected)="changeAutocompleteValue($event)">
                        <mat-option *ngFor="let user of users | filterByPropertyPipe: replyToRecipientSearch: 'email'"
                                    [value]="user.email">
                            {{ user.fullName + ' (' + user.email + ' )' }}
                        </mat-option>
                    </mat-autocomplete>
                    <spinner [spinnerShow]="showUsersSpinner" class="input-center"></spinner>
                </div>
            </div>
            <div class="form-group row">
                <div class="col-xs-2">
                    <label class="title">Subject: </label>
                </div>
                <div class="col-xs-10">
                    <input class="form-control" name="subject" [(ngModel)]="data.subject" required>
                </div>
            </div>
            <div  class="form-group row">
                <div class="col-xs-2">
                    <label class="title">Type: </label>
                </div>
                <div class="col-xs-4">
                    <select class="form-control"
                            name="messageOrNotice"
                            [(ngModel)]="emailMessageType"
                            (ngModelChange)="onTypeChange()" required>
                        <option [ngValue]="'default'">Email Merge</option>
                        <option [ngValue]="'notice'" *ngIf="isHasBuildingsWithPostal()" (click)="es.loadBuildingNotices()">Import from MaxTV</option>
                        <option [ngValue]="'template'">Template</option>
                    </select>
                </div>
                <div *ngIf="emailMessageType == 'notice'" class="col-xs-6">
                    <input matInput #searchNotice
                           [placeholder]="!es.noticePlaylists.length ? 'Empty list' : 'Search Notice'"
                           name="notice"
                           id="searchNotice"
                           class="form-control"
                           (focusout)="searchNotice.value = ''"
                           [disabled]="!es.noticePlaylists.length"
                           [matAutocomplete]="noticesList">
                    <mat-autocomplete #noticesList="matAutocomplete">
                        <mat-optgroup *ngFor="let playlist of es.noticePlaylists" [label]="playlist.title">
                            <mat-option *ngFor="let notice of playlist.announcements | filterByPropertyPipe: searchNotice.value: 'title'"
                                        (click)="searchNotice.blur(); onSelectNotice(notice);">
                                {{ notice.title }} ({{ notice.id }})
                            </mat-option>
                        </mat-optgroup>
                    </mat-autocomplete>
                    <spinner [spinnerShow]="es.isNoticePlaylistsLoading"></spinner>
                </div>
                <div *ngIf="emailMessageType == 'template'" class="col-xs-6">
                    <input matInput #searchTemplate
                           [placeholder]="'Search Template'"
                           name="template"
                           id="searchTemplate"
                           class="form-control"
                           (focusout)="searchTemplate.value = ''"
                           [disabled]="!es.corporations.length"
                           [matAutocomplete]="noticesList">
                    <mat-autocomplete #noticesList="matAutocomplete">
                        <mat-optgroup [label]="'Invitation'">
                            <mat-option *ngFor="let corporation of es.corporations | filterByPropertyPipe: searchTemplate.value: 'name'"
                                        (click)="searchTemplate.blur(); onSelectCorporation(corporation);">
                                {{ corporation.name }} ({{ corporation.subject || 'Invitation email'}})
                            </mat-option>
                        </mat-optgroup>
                    </mat-autocomplete>
                    <spinner [spinnerShow]="es.loadingCorporations"></spinner>
                </div>
            </div>
            <div>
                <div class="form-group" id="summernote">{{data.message}}</div>
                <div class="row m-b-sm">
                    <div class="col-xs-8">
                        <h3>Attachments</h3>
                    </div>
                    <div class="col-xs-4">
                        <input type="file" id="add-attachment-btn" (change)="addFile($event)" [disabled]="disabledFileInput">
                        <label for="add-attachment-btn" class="btn mtv-primary-color">Add Attachment</label>
                    </div>
                </div>
                <ul class="attachment-box m-b-lg">
                    <li *ngFor="let item of data.attachments; let i = index;">
                        <a (click)="es.showAttachment(item)">
                            <div>
                                <span class="file-name">{{item.name}}</span>
                                <span class="file-size">({{+(item.fileSize/1000).toFixed(0)}}kb)</span>
                            </div>
                        </a>
                        <i class="fa fa-trash" (click)="removeFile(i)" title="Delete Attachment"></i>
                    </li>
                </ul>
            </div>

            <spinner [spinnerShow]="es.spinnerShow"></spinner>
            <div class="row btn-box">
                <div class="col-xs-6">
                    <label class="img-checkbox">
                        <input id="sendMeCopy" type="checkbox" name="sendMeCopy" ngModel>
                        <label for="sendMeCopy">
                            <svg-checked></svg-checked>
                        </label>
                        <span>Send a copy to me</span>
                    </label>
                    <label class="img-checkbox" [hidden]="!showSaveAsDefaultInvitation()">
                        <input id="saveAsDefaultInvitation" type="checkbox" name="saveAsDefaultInvitation" ngModel>
                        <label for="saveAsDefaultInvitation">
                            <svg-checked></svg-checked>
                        </label>
                        <span>Save As Default Invitation Message</span>
                    </label>
                </div>
                <div class="btn-group col-xs-3 display-flex">
                        <button tabindex="-1" class="btn btn-default-green save-btn" data-toggle="dropdown"
                            (click)="toggleDropDown()" type="button" [disabled]="disabledSubmit">
                            Save As Draft
                        </button>
                        <button data-toggle="dropdown" class="btn btn-default-green dropdown-toggle dropdown"
                            type="button" aria-expanded="false">
                            <span class="caret"></span>
                        </button>
                        <ul class="dropdown-menu pull-right dropdown-offset">
                            <li><a (click)="saveAndStay()">Save and Stay</a></li>
                            <li><a (click)="saveAndClose()">Save and Close</a></li>
                            <li><a (click)="deleteMail()">
                                Delete
                            </a></li>
                        </ul>
                </div>
                <div class="btn-group col-xs-3 display-flex">
                    <button type="submit" class="btn btn-primary submit-btn" [disabled]="disabledSubmit">Send</button>
                    <button data-toggle="dropdown" class="btn btn-primary dropdown-toggle">
                        <span class="caret"></span>
                    </button>
                    <ul class="dropdown-menu pull-right dropdown-offset">
                        <li (click)="showEmailSchedulingModal()">
                            <a>Send Later</a>
                        </li>
                    </ul>
                </div>
            </div>
        </form>

        <spinner [spinnerShow]="isSpinnerShow"></spinner>
        <spinner [spinnerShow]="es.isUploadImageSpinnerShow"></spinner>
    </main>
</div>

<choice-recipients-modal *ngIf="es.buildings.length && es.isChoiceRecipientsModalShow" (save)="saveRecipients($event)">
</choice-recipients-modal>
<view-attachment-modal *ngIf="es.isViewAttachmentModalShow"></view-attachment-modal>
<email-scheduling-modal *ngIf="es.isEmailSchedulingModalShow" [(message)]="data" (send)="onSubmit(form, false, false)">
</email-scheduling-modal>
<choose-corporation-modal *ngIf="es.isChooseCorporationModalShow" [inviteTemplate]="data.message">
</choose-corporation-modal>



// WEBPACK FOOTER //
// /app/src/app/views/email/compose-email/compose-email.component.html